
import React, { useEffect, useRef } from 'react'

/**
 * useFocus returns a ref which can be used to auto-focus an input.
 */

export default function useFocus() {
  const ref = useRef(null)

  useEffect(_ => {
    if (ref.current) {
      ref.current.focus()
    }
  }, [])

  return ref
}